module.exports = __webpack_public_path__ + "img/swiper-gym.b6f97a54.jpg";